import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Image, Col, Form, Button, Row } from "react-bootstrap";
import moment from "moment";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import IconButton from "@material-ui/core/IconButton";
import SelectFilter from "../../../reusableComponents/selectFilter";
import {
  admin_get_category_menu_setup_date_filter,
  admin_get_items_menu_setup_date_filter,
  get_admin_global_added_templates_date_filter,
} from "../../../../store/actions/SuperAdminActions/adminCreateCatalogue";
import isEmpty from "../../../../store/validation/is-Empty";

const FilterSection = (props) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth?.user?.accessToken);
  const [state, setState] = useState({
    showFilter: false,
    resType: "",
    location: "",
  });
  const [dateQuery, setDateQuery] = useState({
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  const allFoodTypes = useSelector((state) => state.category?.foodtype);

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  useEffect(() => {
    const token = auth;
    if (!isEmpty(dateQuery)) {
      if (props.tabStatus === 1) {
        dispatch(
          admin_get_items_menu_setup_date_filter(
            token,
            dateQuery.startDate,
            dateQuery.endDate,
            onSuccessItemMenuSetup(dateQuery)
          )
        );
      } else if (props.tabStatus === 2) {
        dispatch(
          admin_get_category_menu_setup_date_filter(
            token,
            dateQuery.startDate,
            dateQuery.endDate,
            onSuccessMenuCategory(dateQuery)
          )
        );
      } else if (props.tabStatus === 3) {
        dispatch(
          get_admin_global_added_templates_date_filter(
            token,
            dateQuery.startDate,
            dateQuery.endDate,
            onSuccessAddedTemplates(dateQuery)
          )
        );
      }
    }
  }, [dateQuery]);

  const onSuccessItemMenuSetup = (dateQuery) => {
    const token = auth;
    dispatch(
      admin_get_category_menu_setup_date_filter(
        token,
        dateQuery.startDate,
        dateQuery.endDate
      )
    );
    dispatch(
      get_admin_global_added_templates_date_filter(
        token,
        dateQuery.startDate,
        dateQuery.endDate
      )
    );
  };

  const onSuccessMenuCategory = (dateQuery) => {
    const token = auth;
    dispatch(
      admin_get_items_menu_setup_date_filter(
        token,
        dateQuery.startDate,
        dateQuery.endDate
      )
    );
    dispatch(
      get_admin_global_added_templates_date_filter(
        token,
        dateQuery.startDate,
        dateQuery.endDate
      )
    );
  };

  const onSuccessAddedTemplates = (dateQuery) => {
    const token = auth;
    dispatch(
      admin_get_items_menu_setup_date_filter(
        token,
        dateQuery.startDate,
        dateQuery.endDate
      )
    );
    dispatch(
      admin_get_category_menu_setup_date_filter(
        token,
        dateQuery.startDate,
        dateQuery.endDate
      )
    );
  };

  return (
    <div>
      <div className="row super-admin-toptext-searchbar-icon">
        <div className="col-6">
          <div className="col-9 p-0">
            <Form.Control
              type="text"
              placeholder={
                props.tabStatus === 1
                  ? "Search by item name ,description"
                  : props.tabStatus === 2
                  ? "Search by category name ,description"
                  : props.tabStatus === 3
                  ? "Search by add on name"
                  : "Search"
              }
              onChange={(e) => props.onChange(e.target.value)}
              value={props.search}
              className="amSearch"
            />
          </div>
        </div>
        <div className="col-6">
          <div className="row justify-content-center align-items-center">
            <div className="col-5">
              <div className="mr-3">
                <SelectFilter onDateChange={onDateChangeHandler} />
              </div>
            </div>
            <div className="col-3">
              <div className="d-flex align-items-center justify-content-between">
                {props.sortFilter}
                <div
                  className="f10-400"
                  align="center"
                  onClick={props.handleShowFilter}
                >
                  <img
                    src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                    width="80px"
                  />
                  <br />
                  {/* Filter */}
                </div>
                <div className="f10-400" align="center">
                  {props.downloadreport}
                </div>
              </div>
            </div>
          </div>

          {/* <div className="d-flex justify-content-end align-items-center">
            <div className="text-blue f15-500 mr-3">Sort by</div>
            <FormControl variant="filled" className="enSortSelect">
              <Select
                value={props.selectedSort}
                onChange={(e) => props.sortByChangeCode(e.target.value)}
                inputProps={{
                  name: "SortBy",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                {sortBy.map((data) => {
                  return (
                    <option
                      value={data.id}
                      //defaultValue={props.SortBy}
                      key={data.id}
                    >
                      {data.title}
                    </option>
                  );
                })}
              </Select>
            </FormControl>
            <div className="text-blue f15-500 ml-5 mr-3">Filters</div>
            <IconButton
              className="enDownIcon"
              // onClick={props.handleShowFilter}
            >
              <Image
                src={require("../../../../assets/images/UserManagement/chevron-down.svg")}
                alt="View"
                title="View"
              />
            </IconButton>
          </div> */}
        </div>
      </div>

      {props.showFilter && (
        <div className="row">
          <div className="col-12">
            <div className="enWhiteBox mt-3">
              <Form className="row justify-content-between">
                {props.tabStatus === 1 ? (
                  <Col md={5}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-Restaurant-type">
                          Food type
                        </InputLabel>
                        <Select
                          value={props.resType}
                          onChange={(e) =>
                            props.resTypeChangeHandler(e.target.value)
                          }
                          label="Food type"
                          inputProps={{
                            name: "food_type",
                            id: "outlined-Restaurant-type",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {allFoodTypes &&
                            allFoodTypes.map((data, index) => {
                              return (
                                <MenuItem value={data.title} key={index}>
                                  {data.title}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col>
                ) : (
                  ""
                )}
                {props.tabStatus === 1 ? (
                  <Col md={5}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-item-status">
                          Item Status
                        </InputLabel>
                        <Select
                          value={props.itemStatus}
                          onChange={(e) =>
                            props.itemStatusChangeHandler(e.target.value)
                          }
                          label="Item Status"
                          inputProps={{
                            name: "item_status",
                            id: "outlined-item-status",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <MenuItem value="" disabled>
                            Select Status
                          </MenuItem>
                          <MenuItem value="active">Active</MenuItem>
                          <MenuItem value="inactive">Inactive</MenuItem>
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col>
                ) : (
                  ""
                )}

                <Col md={12}>
                  <div className="d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5"
                      onClick={props.handleShowFilterClosed}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5"
                      onClick={props.handleShowFilterClosed}
                    >
                      Search
                    </Button>
                  </div>
                </Col>
              </Form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterSection;
